<template>
  <div>
    <PageHeading
      default-heading="We're unable to open a trust account for you"
      edit-heading="We're unable to open a trust account for you"
    />
    <form
      novalidate="novalidate"
      @submit.prevent
    >
      <div class="pvd-container container-divider">
        <p>
          {{ userName }}'s phone number, email, or address didn't match the information we have. Make sure you didn't...
        </p>
        <ul>
          <li>enter the wrong phone number</li>
          <li>enter the wrong email</li>
          <li>enter the wrong residential address</li>
        </ul>
      </div>
      <PageNavigation
        show-primary-button-spinner="N"
        enable-exit-modal="Y"
        show-secondary-button="N"
        show-page-spinner="N"
        primary-button-type="button"
        :primary-button-label="getPrimaryButtonLabel"
        :secondary-button-label="getSecondaryButtonLabel"
        :page-exit-url="computedExitUrl"
        @primary-button-clicked="nextButtonClicked"
      />
    </form>
  </div>
</template>
<script>
import utilityFunctions from '../mixins/utility';
import PageHeading from '../components/PageHeading.vue';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import pageNavigationHelper from '../mixins/pageNavigationHelper';
import PageNavigation from '../components/PageNavigation.vue';

export default {
  name: 'TrustCustomerContactMisMatch',
  components: {
    PageNavigation,
    PageHeading,
  },
  mixins: [
    utilityFunctions,
    validationHelper,
    widgetHelper,
    dataHelper,
    dataSanitize,
    pageNavigationHelper,
  ],
  data() {
    return {
      userName: '',
    };
  },
  computed: {
    pageHeader() {
      const pageHeader = this.pd_content.page_header;
      if (pageHeader) {
        const heading = this.cs_editMode ? pageHeader.edit : pageHeader.default;

        if (heading) {
          document.title = this.setTitle(heading);
        }
        return heading;
      }
      return '';
    },
    getPrimaryButtonLabel() {
      return 'Try Again';
    },
  },
  mounted() {
    this.$store.commit('currentState/updateField', { path: 'stateName', value: 'trust-customer-contact-mismatch' });
    const { currentUserIndex } = this.getInstanceData().currentState;
    const { formData } = this.getInstanceData();
    if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
      this.userName = `${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`;
    } else {
      this.userName = `${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`;
    }
  },
  methods: {
    nextButtonClicked(navAction) {
      const instanceData = this.getInstanceData();
      const { additionalUsers } = instanceData.formData;
      this.setListInstanceData('formData', additionalUsers.slice(0, -1), 'additionalUsers');
      this.performPageValidation(navAction).then((valid) => {
        if (valid) {
          this.performNavigation('next');
        }
      });
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
.top-margin-zero {
  margin-top: 0;
}
</style>
